export default __webpack_public_path__ + "static/media/2_icon4A.391643b6.png";